import { useCallback } from 'react'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'

/**
 * The window event the React topbar dispatches to ask the still-AngularJS app
 * shell to toggle its sidenav. Handled in app/directives/sidenav/
 * sidenav.directive.js.
 */
const TOGGLE_SIDEBAR_EVENT = '@@loaded/reactToggleSidebar'

/**
 * The topbar's small-screen-only left button that allows the sidenav to be
 * toggled open / closed.
 *
 * Hidden on desktop layout.
 */
const TopbarMobileButton = () => {
  const handleToggleSidebar = useCallback(() => {
    window.dispatchEvent(new CustomEvent(TOGGLE_SIDEBAR_EVENT))
  }, [])

  return (
    <IconButton
      aria-label="Toggle navigation"
      onClick={handleToggleSidebar}
      sx={{
        display: 'inline-flex',
        '@media (min-width: 1200px)': {
          display: 'none',
        },
        color: (theme) => theme.app.headerTextColor,
      }}
    >
      <MenuIcon />
    </IconButton>
  )
}

export default TopbarMobileButton
